import { timesheetLocales } from "src/locales/timesheetLocales";

export const COMMON_CONSTANTS = {
  API_KEY_OFFICE_CONTRACTS: "office_contracts",
  APPR_TEMPLATE: "T",
  BUTTON_ADD_NEW: " Add New",
  BUTTON_ADD: "Add",
  BUTTON_DELETE: "Delete",
  BUTTON_DISABLE: "Disable",
  BUTTON_EDIT: "Edit",
  BUTTON_ENABLE: "Enable",
  BUTTON_NO: "No",
  BUTTON_YES: "Yes",
  CALENDER_START_DAY: 0,
  CANCEL_BUTTON: "Cancel",
  CATEGORY: {
    CATEGORY_LABEL: {
      JOB_CATEGORY: "Manage Job Category",
      JOB_SKILL: "Manage Job Skills",
      MANAGE_SOFTWARE: "Manage Software",
      SPECIALITY_SKILL: "Specialty Skills",
    },

    MANAGE_SOFTWARE: {
      ADD_MESSAGE: "The Software(s) added successfully.",
      DELETE_MESSAGE: "The Software  deleted successfully.",
      DISABLE_MESSAGE: "The Software disabled successfully.",
      DUPLICATE_MESSAGE: "Software with this name already exists.",
      EDIT_MESSAGE: "The Software updated successfully.",
      ENABLE_MESSAGE: "The Software enabled successfully.",
      NO_CHANGE: "No changes added to software.",
      REQUIRED: "Name of the software is required.",
    },

    SPECIALITY_SKILLS: {
      ADD_MESSAGE: "The Specialty skill(s) added successfully.",
      DELETE_MESSAGE: "The Specialty skill  deleted successfully.",
      DISABLE_MESSAGE: "The Specialty skill disabled successfully.",
      DUPLICATE_MESSAGE: "Specialty skill with this name already exists.",
      EDIT_MESSAGE: "The Specialty skill updated successfully.",
      ENABLE_MESSAGE: "The Specialty skill enabled successfully.",
      NO_CHANGE: "No changes added to specialty skill.",
      REQUIRED: "Name of the specialty skill is required.",
    },
  },
  COLON: ":",
  COMMON_DATA_FIRST_INDEX: 0,
  COMMON_DATA_SECOND_INDEX: 1,
  CONFIRM_BUTTON: "Confirm",
  CONFIRM_DELETE_MESSAGE: "Are you sure want to delete this item",
  CONTENT: "content",
  CONTRACT_TYPE_OTHER: "other",
  CONTRACT_TYPE_NONE: "none",
  CONTRACT_MSA_1: 1,
  CONTRACT_MSA_2: 2,
  CONTRACT_MSA_COMMON: 3,
  CONTRACT_UUID: "contractUuid",
  CONTRACT_WINTER_2026_PAY_SCALE_UUID: "7f83d0ec-eab7-41a9-ac7e-025fbb4e174c",
  CONTRACT_WINTER_2026_A1_UUID: "5b5b3bce-ded5-41ea-be46-6ffe26c34c6d",
  CONTRACT_WINTER_2026_A2_UUID: "08917b2c-d0fa-4cd0-a3b3-233980c4a24e",
  CONTRACT_WINTER_2026_A1_NAME: "Exhibit A-1 Winter 2026",
  CONTRACT_WINTER_2026_A2_NAME: "Exhibit A-2 Winter 2026",
  CURRENCY_SYMBOL: "$",
  DANGER_COLOR: "danger",
  DATA_TYPE: {
    OBJECT: "object",
    STRING: "string",
  },
  DATE: "date",
  DATE_OF_JULY_START: "-07-01",
  DATE_OF_JUNE_END: "-06-30",
  DATE_TIME_PICKER_FORMAT: "YYYY-MM-DD",
  DEFAULT_ACTION_STATE: false,
  DELETE: "DELETE",
  DISABLE: "disable",
  DISABLE_REASONS: "disable_reasons",
  DOCUMENT: {
    FILE_NAME: "file_name",
    UPLOAD_ON: "created_at",
    UPLOAD_BY: "uploaded_by",
  },
  DOUBLE_QUOTES_WITH_COMMA: ",",
  DOUBLE_QUOTES: "",
  DSO: "DSO/DPO",
  DSO_ID: "1",
  EMAIL_REGEX_VALIDATE_EXPRESSION:
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/,
  EMPTY: "",
  ENABLE: "enable",
  FALSE_STATE_VARIABLE: false,
  FIELD_TYPE: {
    DATE: "date",
    DATE_RANGE: "date_range",
    SELECT: "select",
    TEXT: "text",
    MULTI_SELECT: "multiSelect",
    NUMBER: "number",
    SEARCH_DROP_DOWN: "search_drop_down",
    PROFESSIONAL_SEARCH: "professional_search",
    CONTACT_SEARCH: "contact_search",
  },
  HALF_DAY_HOUR: 12,
  HIDE: false,
  HYPHEN: " - ",
  INITIAL: "0",
  INPUT_VALUE_LENGTH: 0,
  INSTRUCTOR: "f56d86d9-a535-421c-ac83-60f61b0f936b",
  JOB_CATEGORIES: "job_categories",
  JOB: {
    DEFAULT_EMPTY: "",
    DEFAULT_PAGINATION_LIMIT_ARRAY: [25, 50, 75],
    DEFAULT_TIMEOUT: 1000,
    FIELDS: {
      ACTION: "action",
      CATEGORY: "category",
      CREATED_DATE: "created_at",
      DAYS_TO_FILL: "days_to_fill",
      JOB_DATE: "job_date",
      JOB_ID: "job_id",
      JOB_TYPE: "day_type",
      LOCATION: "location",
      MILES: "distance",
      OFFICE_NAME: "office_name",
      OFFICE: "office",
      OFFICE_UUID: "office_uuid",
      PLACEMENT_TYPE: "placement_type",
      POSITION: "position",
      JOB_ROLE: "job_role",
      STATE: "state",
      STATUS: "status",
      TYPE: "type",
      START_DATE: "start_date",
      END_DATE: "end_date",
      ZIP_CODE: "zip_code",
      ASSIGNED_TO: "assigned_recruiter",
      RECRUITER: "recruiter",
      ASSIGN: "assign",
      PROFESSIONAL: "professional",
      NO_OF_DAYS_CANCELLED: "no_of_days_cancelled",
      JOB_START_DATES: "job_start_dates",
      CANCELLED_BY: "cancelled_by",
      CANCELLATION_INITIATED_DATE: "cancelled_at",
      PROFESSIONAL_NAME: "professional_name",
      AUTO_PUBLISH: "is_auto_published",
    },
    RECRUITERS: {
      EMAIL: "admin_email",
      NAME: "admin_name",
      DAYS_ASSIGNED: "days_assigned",
      DAYS_CANCELLED: "days_cancelled",
      DAYS_FILLED: "days_filled",
      DAYS_UNFILLED: "days_unfilled",
      TOTAL_ASSIGNMENTS: "total_assignments",
      TOTAL_JOBS: "total_jobs",
    },
    MY_ASSIGNMENTS: {
      POSITION: "position",
      OFFICE_NAME: "office_name",
      DAYS_TO_FILL: "days_to_fill",
      DAYS_CANCELLED: "days_cancelled",
      DAYS_FILLED: "days_filled",
      DAYS_UNFILLED: "days_unfilled",
      STATUS: "assignment_status",
      TOTAL_ASSIGNMENTS: "total_assignments",
      TOTAL_DAYS: "total_days",
    },
    FIELD_TYPE: {
      TEXT: "text",
      NUMBER: "number",
      SELECT: "select",
      DATE: "date",
      DATE_RANGE: "date_range",
    },
    FILTER: {
      NAME: "name",
      SEARCH: "search",
      SORT: "sort",
      TYPE: {
        CITY: "cityUuid",
        DATE: "dateUuid",
        RANGE: "range",
        SELECT: "select",
      },
    },
    FIND_FILTER: {
      APPLICANT_STATUS: "status",
      FIND_PROFESSIONALS: "Find professionals with in the range",
      CITY: "city",
      DATE: "date",
      NAME: "name",
      RANGE: "range",
      ZIP: "zip",
      STATE: "state",
      ROLE: "role",
      TYPE: "type",
    },
    FIND_FILTER_URL_PREFIX: {
      PROFESSIONAL: "fp_",
      PROSPECT: "fpr_",
    },
    FIND_SELECTED_KEY: "selected",
    JOB_TYPES: {
      0: {
        KEY: "directHire",
        TYPE: "primary",
        VALUE: 0,
      },
      1: {
        KEY: "singleDay",
        TYPE: "primary",
        VALUE: 1,
      },
      2: {
        KEY: "multiDay",
        TYPE: "secondary",
        VALUE: 2,
      },
    },
    JOB_STATUS: {
      1: {
        KEY: "open",
        TYPE: "dd-open",
        VALUE: 1,
      },
      2: {
        KEY: "published",
        TYPE: "dd-published",
        VALUE: 2,
      },
      3: {
        KEY: "hired",
        TYPE: "dd-hired",
        VALUE: 3,
      },
      4: {
        KEY: "completed",
        TYPE: "dd-completed",
        VALUE: 4,
      },
      5: {
        KEY: "cancelled",
        TYPE: "dd-cancelled",
        VALUE: 5,
      },
      6: {
        KEY: "rejected",
        TYPE: "dd-rejected",
        VALUE: 6,
      },
      7: {
        KEY: "unfilled",
        TYPE: "dd-unfilled",
        VALUE: 7,
      },
    },
    SERVICE_TYPE: {
      1: {
        KEY: "open",
        TYPE: "1",
        VALUE: 1,
      },
      2: {
        KEY: "published",
        TYPE: "2",
        VALUE: 2,
      },
      3: {
        KEY: "hired",
        TYPE: "3",
        VALUE: 3,
      },
    },
    APPLICANT_STATUS: {
      1: {
        KEY: "applied",
        VALUE: 1,
      },
      2: {
        KEY: "assigned",
        VALUE: 2,
      },
      3: {
        KEY: "completed",
        VALUE: 3,
      },
      4: {
        KEY: "cancelled",
        VALUE: 4,
      },
      5: {
        KEY: "fulfilled",
        VALUE: 5,
      },
    },
    ASSIGN_TYPES: { ASSIGNED: 1, UNASSIGNED: 0 },
    MENU: {
      CANCEL: "cancel",
      EDIT: "edit",
      PUBLISH: "Publish",
      REJECT: "Reject",
      VIEW: "View",
    },
    PAYLOAD: {
      DEFAULT_LIMIT: 25,
      DEFAULT_PAGE: 1,
      DEFAULT_SORT: "DESC",
    },
    PLACEMENT_TYPE: {
      CONTRACT_HIRE: 1,
      CONVERSION_HIRE: 3,
      DIRECT_HIRE: 2,
    },
    SORT: "sort_by",
    STATUS: {
      CANCEL: 5,
      COMPLETED: 4,
      OPEN: 1,
      PENDING: 1,
      PUBLISH: 2,
      REJECT: 6,
    },
  },
  JOB_ID: "jobUuid",
  STEPS: { ONE: 1, TWO: 2, THREE: 3 },
  KEYWORD_STRING: "string",
  KEYWORD: "Enter",
  LABEL_NAME: "username",
  LAZY_LOADING: "loading..",
  LEAD_ZERO: "0",
  LENGTH_OF_COLUMN_DEF: 0,
  LENGTH_OF_FILTERED_DATA: 0,
  LICENCE: "licenses",
  LOADING_STATE_FALSE: false,
  LOADING_STATE_TRUE: true,
  LOCAL_STORAGE_ACCESS_TOKEN: "ACCESS_TOKEN",
  LOCALE_EN_GB: "en-GB",
  LOGIN_FAIL_UNAUTHORIZED: "Invalid Email/ Password. Please try again.",
  LOGIN_FORM_LOGO: "/assets/images/dds-start-logo.png",
  LOGOUT_MESSAGE: "You have been successfully logged out",
  LOGOUT_SUCCESS: "success",
  MODAL_STATE_FALSE: false,
  MODAL_STATE_TRUE: true,
  MONTH_DATE_YEAR_TIME: "MM-DD-YYYY hh:mm:ss A",
  NEW_LINE: "\n",
  NOTE_UUID: "noteUuid",
  OFFICE_TYPE_ONE: 1,
  OFFICE_TYPE_TWO: 2,
  OFFICE_UUID: "officeUuid",
  PROSPECT_UUID: "prospectUuid",
  CONTACT_UUID: "contactUuid",
  OLD_PASSWORD_ERROR: "The old password provided does not match.",
  PAGE_CONSTANTS: [10, 20, 50, 100],
  PAGE_DEFAULT: 10,
  PAGE_DEFAULT_LIMIT: 20,
  PAGINATION: {
    ICON_INNER_SIZE: 30,
    ICON_WRAP_SIZE: 21,
    START_PAGE: 1,
    PAGE_INTERVAL: 1,
  },
  PAGINATION_DEFAULT_PAGE: 1,
  PAGINATION_DEFAULT_LIMIT: 25,
  PAGINATION_DEFAULT_VALUE: 0,
  PAGINATION_TYPE_FROM: "from",
  PAGINATION_TYPE_TO: "to",
  PAGINATION_PAGE: "page",
  PAGINATION_LIMIT: "limit",
  PASSWORD_ERROR_MESSAGE: "Failed to change the password! Please try again",
  PASSWORD_NOT_MATCH: "The New Password and Confirm password do not match",
  PASSWORD_SUCCESS_MESSAGE: "Your password has been changed successfully",
  PASSWORD_VALIDATION:
    "Must contain a minimum of 8 characters, 1 uppercase letter, 1 numeric digit & 1 special character.",
  PAYROLL_JOB: 2,
  PRIVATE: "PP/Multi",
  PRIVATE_ID: "2",
  PROFESSIONAL_CONTRACTS: "professional_contracts",
  PROFESSIONAL_UUID: "professionalUuid",
  PREVIOUS_PAGE_ROUTE_NAVIGATE: -1,
  RAFFLE_ENTRY: "12166fbb-6320-42ec-ab5b-3c4f4f2f7a70",
  REVENUE: {
    EMAIL: "email",
    ID: "staff_id",
    NAME: "name",
    ROLE: "role",
    BILL_RATE: "total_bill_rate",
    USER_ID: "user_uuid",
    CREDIT_AMOUNT: "total_credit_memo",
  },
  REVENUE_USER: {
    AMOUNT: "amount",
    CITY: "city",
    DATE: "start_date",
    EMPLOYEE_NAME: "professional_name",
    ID: "job_id",
    OFFICE_NAME: "office_name",
    ROLE: "job_category",
    STATE: "state",
  },
  MANUAL_INVOICE: {
    PROFESSIONAL_NAME: "professional_name",
    ID: "invoice_number",
    NAME: "office_name",
    ROLE: "role",
    BILL_RATE: "bill_rate",
    DATE_RANGE: "invoice_week",
    HOURS: "total_hours",
    DESCRIPTION: "description",
    TOTAL_AMOUNT: "total_amount",
  },
  RESPONSE_TIME_OUT: 2000,
  SALUTATION: { MR: "Mr.", MS: "Ms.", MRS: "Mrs.", DR: "Dr." },
  SELECET_ALL: "all",
  SHOW: true,
  SIDEBAR_LOGO: "/assets/images/dds-start-logo.png",
  SINGLE_MONTH: 1,
  SKILLS_LENGTH_CHECK: 0,
  SPACE: " ",
  SPACE_WITH_CAOMMA: ", ",
  STATUS_FALSE: false,
  STATUS_TRUE: true,

  SUBMIT_BUTTON: "Confirm",
  TAB_INDEX_FIRST: 0,
  TAB_INDEX_SECOND: 1,
  TABLE_DEFAULT_FLEX: 1,
  TABLE_FILTER_DEFAULT: false,
  TABLE_NO_DETAILS: "No results found.",
  TAG_USER_BY_ID: "taggedByUuid",
  TAG_USER_ID: "taggedUserUuid",
  TEN_MIN: 10,
  TIMESHEET: {
    DEFAULT_PAGINATION_LIMIT_ARRAY: [25, 50, 75],
    LATE_TIMESHEET_SUBMISSIONS: "Late Timesheet Submissions",
    LIST_FIELDS: {
      ACTIONS: "actions",
      ID: "staff_id",
      PRO_NAME: "name",
      START_DATE: "start_date",
      END_DATE: "end_date",
      TOTAL_BILLABLE_HOURS: "total_billable_hours",
      TOTAL_BILL_RATE: "total_bill_rate",
      TOTAL_PAY_RATE: "total_pay_rate",
      TYPE: "type",
      VIEW: "view",
    },
    PRO_FIELDS: {
      ACTIONS: "actions",
      DATE: "date",
      JOB_ID: "job_id",
      JOB_ROLE: "job_role",
      JOB_TYPE: "service_type",
      OFFICE_NAME: "office_name",
      PAYMENT_REQUIRED: "payment",
      BILLABLE_HOURS: "billable_hours",
      STATUS: "status",
      VIEW: "view",
      SUBMITTED_DATE: "submitted_at",
    },
    REFERRAL_JOB_TYPE: 3,
    TIME_PAYLOAD_FORMAT: "yyyy-MM-dd",
    TIMESHEET_DISPUTE: "Timesheet Dispute",
    TIMESHEET_ENTRIES: "Timesheet Entries",
    PAYMENT: "Payment",
    TIMESHEET_STATUS: {
      1: {
        KEY: "pending",
        LABEL: timesheetLocales.statusList.pending,
        TYPE: "secondary",
        VALUE: 1,
      },
      2: {
        KEY: "submitted",
        LABEL: timesheetLocales.statusList.submitted,
        TYPE: "primary",
        VALUE: 2,
      },
      3: {
        KEY: "approved",
        LABEL: timesheetLocales.statusList.approved,
        TYPE: "success",
        VALUE: 3,
      },
      4: {
        KEY: "rejected",
        LABEL: timesheetLocales.statusList.rejected,
        TYPE: "dark",
        VALUE: 4,
      },
      5: {
        KEY: "cancelled",
        LABEL: timesheetLocales.statusList.cancelled,
        TYPE: "danger",
        VALUE: 5,
      },
      6: {
        KEY: "dispute_raised",
        LABEL: timesheetLocales.statusList.disputeRaised,
        TYPE: "warning",
        VALUE: 6,
      },
    },
    TIMESHEET_TIME_FORMAT: "HH:mm A",
    TIMESHEET_TIME_WITH_LOCALE: "HH [Hrs] mm [Mnts]",
    UUID: "id",
    WEEK_START_END_TIME_CONSTANT: 1,
    HOURS_MINUTE: "HH:mm",
    HOURS_MINUTE_A: "hh:mm A",
  },
  TIME_FORMAT_CONSTAT: "MM-DD-YYYY",
  TITLE: "title",
  TOAST_SUCCESS: "success",
  TODAY: "Today",
  TRUE_STATE_VARIABLE: true,
  TWO_DIGIT_DATA: 2,
  TYPE: "type",
  USER: {
    ACTION: "action",
    EMAIL: "email",
    NAME: "name",
    ROLE: "role",
    STAFF_ID: "staff_id",
    STATUS: "status",
    USER_ID: "uuid",
    USER_STATUSES: [
      { TYPE: "warning", VALUE: "Incomplete" },
      { TYPE: "secondary", VALUE: "Submitted" },
      { TYPE: "secondary", VALUE: "In Review" },
      { TYPE: "success", VALUE: "Active" },
      { TYPE: "danger", VALUE: "Inactive" },
      { TYPE: "remove", VALUE: "Removed" },
    ],
  },
  PROFILE_ENABLE_BY_ADMIN: 1,
  PROFILE_DISABLE_BY_ADMIN: 2,
  OFFICE_PROFILE_ADD_BY_ADMIN: 3,
  OFFICE_PROFILE_EDIT_BY_ADMIN: 4,
  PROFESSIONAL_PROFILE_ADD_BY_ADMIN: 5,
  PROFESSIONAL_PROFILE_EDIT_BY_ADMIN: 6,
  OFFICE_RELEASE_CONTRACT_BY_ADMIN: 7,
  OFFICE_PROFILE_APPROVE_BY_ADMIN: 8,
  OFFICE_PROFILE_REJECT_BY_ADMIN: 9,
  PROFESSIONAL_RELEASE_CONTRACT_BY_ADMIN: 10,
  PROFESSIONAL_PROFILE_APPROVE_BY_ADMIN: 11,
  PROFESSIONAL_PROFILE_REJECT_BY_ADMIN: 12,
  RESOLVE_DISPUTE_BY_ADMIN: 13,
  USER_ACCOUNT_DISABLED_TYPE: 2,
  USER_ACCOUNT_ENABLED_TYPE: 1,
  USER_DELETE_REASON: "user_delete_reason",
  USER_TYPE: { OFFICE: 1, PROFESSIONAL: 2 },
  UUID: "uuid",
  VALUE_TWO: 2,
  VARIABLE_BOOLEAN: "boolean",
  VARIABLE_NEGATIVE_ONE: -1,
  VARIABLE_ONE: 1,
  VARIABLE_SEARCH: "Search",
  VARIABLE_ZERO: 0,
  VIEW_STATE_FALSE: false,
  VIEW_STATE_TRUE: true,
  TIME_FORMAT: "hh:mm A",
  REFERRALS: "referrals",
  PROSPECTS_RECRUITER_STATUSES: [
    { label: "Hot", value: "hot" },
    { label: "Cold", value: "cold" },
  ],
  YES: true,
  NO: false,
  TRANSAPARENCY_MODEL: 2,
};
